import pathname, { menuType } from '../../../constants/pathname'

export const newSubProjectSchema = {
  alwaysOpenKeys: ['PROPOSAL_MENU'],
  menu: '',
  sidebars: [
    {
      id: 'MANAGEMENT_MENU',
      type: 'nav',
      remark: null,
      numberOfStep: 0,
      currentStep: 0,
      menuSeq: 0,
      items: [
        {
          eventKey: 'MANAGEMENT_MENU',
          icon: {
            name: 'sitemap',
            color: '',
          },
          link: pathname.subProject.subProjectPage,
          children: 'จัดการโครงการย่อย',
          param: '',
          paramName: '',
          isDisabled: false,
          viewMode: false,
          feedback: false,
        },
      ],
      haveEndSectionLine: false,
      fixedMenu: false,
      titleItem: null,
    },
    {
      id: 'OVERVIEW_MENU',
      type: 'nav',
      remark: null,
      numberOfStep: 0,
      currentStep: 0,
      menuSeq: 1,
      items: [
        {
          eventKey: 'OVERVIEW_MENU_COWORKER',
          icon: { name: 'dashboard', color: '#2da888' },
          link: pathname.subProjectNew.overview,
          children: 'ภาพรวมข้อเสนอโครงการย่อย',
          param: '',
          paramName: '',
          isDisabled: false,
          viewMode: false,
          feedback: false,
        },
      ],
      haveEndSectionLine: false,
      fixedMenu: false,
      titleItem: null,
    },
    {
      id: 'REVIEW_MENU',
      type: 'dropdown',
      remark: null,
      numberOfStep: 0,
      currentStep: 0,
      menuSeq: 3,
      items: [
        {
          eventKey: 'REVIEW_MENU_1',
          icon: { name: 'file-text-o', color: '' },
          link: pathname.subProjectNew.review.paymentSave,
          children: 'บันทึกงวดเงิน',
          param: '',
          paramName: '',
          isDisabled: false,
          viewMode: false,
          feedback: false,
        },
        {
          eventKey: 'REVIEW_MENU_2',
          icon: { name: 'file-text-o', color: '' },
          link: pathname.subProjectNew.review.reviewSave,
          children: 'บันทึกผลการพิจารณากลั่นกรอง และสรุปผล',
          param: '',
          paramName: '',
          isDisabled: false,
          viewMode: false,
          feedback: false,
        },
      ],
      haveEndSectionLine: false,
      fixedMenu: false,
      titleItem: {
        eventKey: 'REVIEW_MENU',
        placement: 'rightStart',
        title: 'กลั่นกรองทางวิชาการ',
        icon: 'filter',
      },
    },
    {
      id: 'APPROVED_MENU',
      type: 'dropdown',
      remark: null,
      numberOfStep: 0,
      currentStep: 0,
      menuSeq: 10,
      items: [
        {
          eventKey: 'APPROVED_MENU_1',
          icon: {
            name: 'check-circle',
            color: '#2da888',
          },
          link: '/proposal-subproject/review/payment-check-subproject',
          children: 'ขั้นที่ 1 ตรวจสอบงวดเงิน',
          param: '',
          paramName: '',
          isDisabled: false,
          viewMode: false,
          feedback: false,
        },
        {
          eventKey: 'APPROVED_MENU_2',
          icon: {
            name: 'check-circle',
            color: '#2da888',
          },
          link: '/proposal-subproject/review/grantee-for-staff-subproject',
          children: 'ขั้นที่ 2 ตรวจสอบข้อมูลผู้รับทุน',
          param: '',
          paramName: '',
          isDisabled: false,
          viewMode: false,
          feedback: false,
        },
        {
          eventKey: 'APPROVED_MENU_3',
          icon: {
            name: 'check-circle',
            color: '#14997a',
          },
          link: '/proposal-subproject/review/subproject-approval-summary',
          children: 'ขั้นที่ 3 สรุปผลการพิจารณาอนุมัติโครงการ',
          param: '',
          paramName: '',
          isDisabled: false,
          viewMode: false,
          feedback: false,
        },
      ],
      haveEndSectionLine: false,
      fixedMenu: false,
      titleItem: {
        eventKey: 'APPROVED_MENU',
        placement: 'rightStart',
        title: 'พิจารณาอนุมัติโครงการ',
        icon: 'pencil',
      },
    },
    {
      id: 'CONTRACT_MENU',
      type: 'nav',
      remark: null,
      numberOfStep: 0,
      currentStep: 0,
      menuSeq: 20,
      items: [
        {
          eventKey: 'CONTRACT_MENU_1',
          icon: {
            name: 'print',
            color: '',
          },
          link: '/subproject/contract',
          children: 'พิมพ์สัญญา/แนบสัญญาที่ลงนามแล้ว',
          param: '',
          paramName: '',
          isDisabled: false,
          viewMode: false,
          feedback: false,
        },
      ],
      haveEndSectionLine: false,
      fixedMenu: false,
      titleItem: null,
    },
    // {
    //   id: 'WITHDRAW_MENU',
    //   type: 'dropdown',
    //   remark: null,
    //   numberOfStep: 0,
    //   currentStep: 0,
    //   menuSeq: 21,
    //   items: [
    //     {
    //       eventKey: 'WITHDRAW_MENU_1_1',
    //       icon: {
    //         name: 'check-circle',
    //         color: '',
    //       },
    //       link: '/proposal-subproject/withdraw/withdraw-request-subproject',
    //       children: 'ขอเบิกงวดที่  1',
    //       param: '?A0973FCD-4C62-4975-8423-A948223669EB',
    //       paramName: '',
    //       isDisabled: false,
    //       viewMode: false,
    //       feedback: false,
    //     },
    //     {
    //       eventKey: 'WITHDRAW_MENU_1_2',
    //       icon: {
    //         name: 'check-circle',
    //         color: '',
    //       },
    //       link: '/proposal-subproject/withdraw/withdraw-request-subproject',
    //       children: 'ขอเบิกงวดที่  2',
    //       param: '?04063109-2663-4D05-94F1-1D83FD215527',
    //       paramName: '',
    //       isDisabled: true,
    //       viewMode: false,
    //       feedback: false,
    //     },
    //     {
    //       eventKey: 'WITHDRAW_MENU_1_3',
    //       icon: {
    //         name: 'check-circle',
    //         color: '',
    //       },
    //       link: '/proposal-subproject/withdraw/withdraw-request-subproject',
    //       children: 'ขอเบิกงวดที่  3',
    //       param: '?856BC9CA-290E-4F0D-BEA7-FC2202CB7DAA',
    //       paramName: '',
    //       isDisabled: true,
    //       viewMode: false,
    //       feedback: false,
    //     },
    //   ],
    //   haveEndSectionLine: false,
    //   fixedMenu: false,
    //   titleItem: {
    //     eventKey: 'WITHDRAW_MENU',
    //     placement: 'rightStart',
    //     title: 'ขอเบิกงวดเงิน',
    //     icon: 'pencil',
    //   },
    // },
    {
      id: 'CLOSE_PROJECT_MENU',
      type: 'nav',
      remark: null,
      numberOfStep: 0,
      currentStep: 0,
      menuSeq: 30,
      items: [
        {
          eventKey: 'CLOSE_PROJECT_MENU_1',
          icon: {
            name: '',
            color: '',
          },
          link: '/proposal-subproject/close-project',
          children: 'ปิดโครงการ',
          param: '',
          paramName: '',
          isDisabled: false,
          viewMode: false,
          feedback: false,
        },
      ],
      haveEndSectionLine: false,
      fixedMenu: false,
      titleItem: null,
    },
    {
      id: 'CHANGE_PROJECT_STATUS_MENU',
      type: 'nav',
      remark: null,
      numberOfStep: 0,
      currentStep: 0,
      menuSeq: 31,
      items: [
        {
          eventKey: 'CHANGE_PROJECT_STATUS_MENU_1',
          icon: {
            name: 'pencil',
            color: '',
          },
          link: '/proposal-subproject/change-project-status',
          children: 'เปลี่ยนแปลงสถานะโครงการ',
          param: '',
          paramName: '',
          isDisabled: false,
          viewMode: false,
          feedback: false,
        },
      ],
      haveEndSectionLine: false,
      fixedMenu: false,
      titleItem: null,
    },
    {
      id: 'PROPOSAL_MENU',
      type: 'dropdown',
      titleItem: {
        eventKey: 'PROPOSAL_MENU',
        placement: 'rightStart',
        title: 'ข้อเสนอโครงการ',
        icon: 'file-text',
      },
      items: [
        {
          eventKey: '1',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.projectName,
          children: '1.ชื่อโครงการ',
        },
        {
          eventKey: '2',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.projectProponent,
          children: '2.ผู้เสนอโครงการ',
        },
        {
          eventKey: '3',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.projectResponsibler,
          children: '3.ผู้รับผิดชอบโครงการ/ผู้รับทุน',
        },
        {
          eventKey: '4',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.projectCoMaker,
          children: '4.ผู้ร่วมทำโครงการ',
        },
        {
          eventKey: '5',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.projectFeature,
          children: '5.คุณสมบัติพื้นฐานและลักษณะต้องห้ามผู้เสนอโครงการ',
        },
        {
          eventKey: '6',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.projectBackground,
          children: '6.ความเป็นมา/หลักการและเหตุผล/ความสำคัญของปัญหา',
        },
        {
          eventKey: '7',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.projectObjectiveOutcomeIndicator,
          children: '7.วัตถุประสงค์ ผลลัพธ์และตัวชี้วัด',
        },
        {
          eventKey: '8',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.targetOperationArea,
          children: '8.กลุ่มเป้าหมายและพื้นที่ดำเนินการ',
        },
        {
          eventKey: '9',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.operatingPeriod,
          children: '9.ระยะเวลาดำเนินงาน',
        },
        {
          eventKey: '10',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.activities,
          children: '10.กิจกรรมการดำเนินงาน/แผนการดำเนินงาน',
        },
        {
          eventKey: '11',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.otherSupport,
          children: '11.กรณีที่มีการสนับสนุนทรัพยากรจากหน่วยงานอื่น',
        },
        {
          eventKey: '12',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.resultsReport,
          children: '12.วิธีรายงานผลลัพธ์ของโครงการ',
        },
        {
          eventKey: '13',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.partner,
          children: '13.องค์กรภาคีที่ร่วมดำเนินงาน',
        },
        {
          eventKey: '14',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.attachments,
          children: '14.เอกสารแนบท้ายโครงการ',
        },
        {
          eventKey: '15',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.appendix,
          children: '15.ภาคผนวก',
        },
      ],
    },
  ],
}

export const newSubProjectSettingSchema = {
  alwaysOpenKeys: ['1', 'PROPOSAL_MENU'],
  menu: menuType.search,
  sidebars: [
    {
      id: 'section1',
      type: 'nav',
      items: [
        {
          eventKey: '0',
          icon: {
            name: 'home',
          },
          link: pathname.subProjectNew.settingProposal.templeteManage,
          children: 'หน้าหลักตั้งค่า Templete โครงการย่อย',
        },
        {
          eventKey: '0',
          icon: {
            name: 'file-text-o',
          },
          link: pathname.subProjectNew.settingProposal.templeteDetail,
          children: 'จัดการ Templete โครงการย่อย',
        },
      ],
    },

    {
      id: 'PROPOSAL_MENU',
      type: 'dropdown',
      titleItem: {
        eventKey: 'PROPOSAL_MENU',
        placement: 'rightStart',
        title: 'ข้อเสนอโครงการ',
        icon: 'file-text',
      },
      items: [
        {
          eventKey: '1',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.settingProposal.projectName,
          children: '1.ชื่อโครงการ',
        },
        {
          eventKey: '2',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.settingProposal.projectProponent,
          children: '2.ผู้เสนอโครงการ',
        },
        {
          eventKey: '3',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.settingProposal.projectResponsibler,
          children: '3.ผู้รับผิดชอบโครงการ',
        },
        {
          eventKey: '4',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.settingProposal.projectCoMaker,
          children: '4.ผู้ร่วมทำโครงการ',
        },
        {
          eventKey: '5',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.settingProposal.projectFeature,
          children: '5.คุณสมบัติพื้นฐานและลักษณะต้องห้ามผู้เสนอโครงการ',
        },
        {
          eventKey: '6',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.settingProposal.projectBackground,
          children: '6.ความเป็นมา/หลักการและเหตุผล/ความสำคัญของปัญหา',
        },
        {
          eventKey: '7',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.settingProposal.projectObjectiveOutcomeIndicator,
          children: '7.วัตถุประสงค์ ผลลัพธ์และตัวชี้วัด',
        },
        {
          eventKey: '8',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.settingProposal.targetOperationArea,
          children: '8.กลุ่มเป้าหมายและพื้นที่ดำเนินการ',
        },
        {
          eventKey: '9',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.settingProposal.operatingPeriod,
          children: '9.ระยะเวลาดำเนินงาน',
        },
        {
          eventKey: '10',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.settingProposal.activities,
          children: '10.กิจกรรมการดำเนินงาน/แผนการดำเนินงาน',
        },
        {
          eventKey: '11',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.settingProposal.otherSupport,
          children: '11.กรณีที่มีการสนับสนุนทรัพยากรจากหน่วยงานอื่น',
        },
        {
          eventKey: '12',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.settingProposal.resultsReport,
          children: '12.วิธีรายงานผลลัพธ์ของโครงการ',
        },
        {
          eventKey: '13',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.settingProposal.partner,
          children: '13.องค์กรภาคีที่ร่วมดำเนินงาน',
        },
        {
          eventKey: '14',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.settingProposal.attachments,
          children: '14.เอกสารแนบท้ายโครงการ',
        },
        {
          eventKey: '15',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.settingProposal.appendix,
          children: '15.ภาคผนวก',
        },
      ],
    },
  ],
}

export const oldSubProjectSchema = {
  alwaysOpenKeys: ['PROPOSAL_MENU'],
  menu: '',
  sidebars: [
    {
      id: 'MANAGEMENT_MENU',
      type: 'nav',
      remark: null,
      numberOfStep: 0,
      currentStep: 0,
      menuSeq: 0,
      items: [
        {
          eventKey: 'MANAGEMENT_MENU',
          icon: {
            name: 'sitemap',
            color: '',
          },
          link: pathname.subProject.subProjectPage,
          children: 'จัดการโครงการย่อย',
          param: '',
          paramName: '',
          isDisabled: false,
          viewMode: false,
          feedback: false,
        },
      ],
      haveEndSectionLine: false,
      fixedMenu: false,
      titleItem: null,
    },
    {
      id: 'OVERVIEW_MENU',
      type: 'nav',
      remark: null,
      numberOfStep: 0,
      currentStep: 0,
      menuSeq: 1,
      items: [
        {
          eventKey: 'OVERVIEW_MENU_COWORKER',
          icon: { name: 'dashboard', color: '#2da888' },
          link: pathname.subProjectNew.overview,
          children: 'ภาพรวมข้อเสนอโครงการย่อย',
          param: '',
          paramName: '',
          isDisabled: false,
          viewMode: false,
          feedback: false,
        },
      ],
      haveEndSectionLine: false,
      fixedMenu: false,
      titleItem: null,
    },
    {
      id: 'PROPOSAL_MENU',
      type: 'dropdown',
      titleItem: {
        eventKey: 'PROPOSAL_MENU',
        placement: 'rightStart',
        title: 'ข้อเสนอโครงการ',
        icon: 'file-text',
      },
      items: [
        {
          eventKey: '1',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.projectName,
          children: '1.ชื่อโครงการ',
        },
        {
          eventKey: '2',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.projectProponent,
          children: '2.ผู้เสนอโครงการ',
        },
        {
          eventKey: '3',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.projectResponsibler,
          children: '3.ผู้รับผิดชอบโครงการ/ผู้รับทุน',
        },
        // {
        //   eventKey: '4',
        //   icon: {
        //     name: 'check-circle',
        //   },
        //   link: pathname.subProjectNew.proposal.projectCoMaker,
        //   children: '4.ผู้ร่วมทำโครงการ',
        // },
        // {
        //   eventKey: '5',
        //   icon: {
        //     name: 'check-circle',
        //   },
        //   link: pathname.subProjectNew.proposal.projectFeature,
        //   children: '5.คุณสมบัติพื้นฐานและลักษณะต้องห้ามผู้เสนอโครงการ',
        // },
        {
          eventKey: '6',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.projectBackground,
          children: '4.ความเป็นมา/หลักการและเหตุผล/ความสำคัญของปัญหา',
        },
        {
          eventKey: '7',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.projectObjectiveOutcomeIndicator,
          children: '5.วัตถุประสงค์ ผลลัพธ์และตัวชี้วัด',
        },
        {
          eventKey: '5',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.projectGoal,
          children: '6. ความสอดคล้องของโครงการ กับเป้าหมายเชิงยุทธศาสาตร์ 10 ปี',
        },
        {
          eventKey: '8',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProject.targetSettingSubProject,
          children: '7.กลุ่มเป้าหมายและพื้นที่ดำเนินการ',
        },
        {
          eventKey: '9',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.operatingPeriod,
          children: '8.ระยะเวลาดำเนินงาน',
        },
        {
          eventKey: '10',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.activities,
          children: '9.กิจกรรมการดำเนินงาน/แผนการดำเนินงาน',
        },
        {
          eventKey: '11',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.otherSupport,
          children: '10.กรณีที่มีการสนับสนุนทรัพยากรจากหน่วยงานอื่น',
        },
        {
          eventKey: '12',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.resultsReport,
          children: '11.วิธีรายงานผลลัพธ์ของโครงการ',
        },
        // {
        //   eventKey: '13',
        //   icon: {
        //     name: 'check-circle',
        //   },
        //   link: pathname.subProjectNew.proposal.partner,
        //   children: '13.องค์กรภาคีที่ร่วมดำเนินงาน',
        // },
        {
          eventKey: '14',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.attachments,
          children: '12.เอกสารแนบท้ายโครงการ',
        },
        {
          eventKey: '15',
          icon: {
            name: 'check-circle',
          },
          link: pathname.subProjectNew.proposal.appendix,
          children: '13.ภาคผนวก',
        },
      ],
    },
  ],
}
